/* eslint-disable no-underscore-dangle */
import gql from "graphql-tag.macro";

const gqlLoadProjectConfig = gql`
  # Write your query or mutation here
  query loadProject {
    currentProject {
      ... on Project {
        _id
        settings
      }
    }
  }
`;

const gqlUpdateDefaultProjectConfig = gql`
  mutation updateDefaultProjectConfig($config: String!) {
    updateDefaultProjectConfig(config: $config)
  }
`;

const gqlUpdateProjectConfig = gql`
  mutation updateProjectSettings($settings: String!) {
    updateProjectSettings(settings: $settings)
  }
`;

export const loadProjectConfig = async ({ client }) => {
  const { data: { currentProject: { settings } } = []} = await client.query({
    query: gqlLoadProjectConfig,
    fetchPolicy: "no-cache",
  });
  return JSON.parse(settings || "[]");
};

export const updateProjectConfig = async ({ config }, { client }) => {

  try {
    const { data } = await client.mutate({
      mutation: gqlUpdateProjectConfig,
      variables: { settings: JSON.stringify(config) },
    });
    
    return data?.updateProjectSettings || false;
  } catch (error) {
    throw new Error(error?.message || "Failed to update project config");
  }

};

export const updateInstanceDefaultProjectConfig = async ({ config }, { client }) => {
  const { data: { updateDefaultProjectConfig: isOk } = false } = await client.mutate({
    mutation: gqlUpdateDefaultProjectConfig,
    variables: { config: JSON.stringify(config) },
  });
  return isOk;
};
